import React from 'react';
import classNames from 'classnames';
import styles from './TitleWithGradient.module.scss';

interface Props {
  title: string | React.ReactNode;
  className?: string;
}

const TitleWithGradient: React.FC<Props> = ({ title, className }) => (
  <p className={classNames(styles.titleWithGradient, className)}>{title}</p>
);

export default TitleWithGradient;
